import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./HomePage.css";
import moment from "moment";

const getEmptyFuelData = () => ({
  diesel_ust1_stock: "",
  petrol_ust2_stock: "",
  petrol_ust3_stock: "",
  diesel_ust4_stock: "",
  dieseldensity_ust1: "",
  petroldensity_ust2: "",
  petroldensity_ust3: "",
  dieseldensity_ust4: "",
  diesel_ust1_rate: "",
  petrol_ust2_rate: "",
  petrol_ust3_rate: "",
  diesel_ust4_rate: "",
  manager: "",
  operator: "",
  managerconatct: "",
  operatorcontact: "",
  pesono: "",
  gstnoreliancebp: "",
  gstvalidity: "",
  gstnorbml: "",
  updated_date: "",
});

const HomePage = () => {
  const { siteId } = useParams();
  const [fuelData, setFuelData] = useState(getEmptyFuelData());

  useEffect(() => {
    const fetchFuelData = async () => {
      if (!siteId) {
        setFuelData(getEmptyFuelData());
        return;
      }

      try {
        const siteIdInt = parseInt(siteId, 10);
        if (isNaN(siteIdInt)) {
          setFuelData(getEmptyFuelData());
          return;
        }

        const response = await axios.get("/fuel-data", {
          params: {
            site_id: siteIdInt,
          },
        });
        console.log(response.data);
        setFuelData(response.data);
      } catch (error) {
        console.error("Error fetching fuel data:", error);
        setFuelData(getEmptyFuelData());
      }
    };

    fetchFuelData();
  }, [siteId]);

  useEffect(() => {
    const interval = setInterval(() => {
      window.location.reload();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const headerStyle = {
    textAlign: "center",
    fontSize: "2.5rem",
    fontWeight: "bold",
  };

  const subHeaderStyle = {
    fontWeight: "normal",
    fontSize: "2rem",
  };

  const cellStyle = {
    backgroundColor: "#000",
    // backgroundColor: "#ffffffff",
    padding: "2rem",
    margin: "2rem",
    textAlign: "center",
    borderRadius: "0.5rem",
    border: "2px solid #ffffff",
    // border: "2px solid #000000ff",
  };

  const redText = {
    color: "#ffffffff",
    fontWeight: "bold",
    fontSize: "3rem",
  };

  return (
    <>
      <div className="container">
        <div className="header" style={{ position: "relative", height: "15%" }}>
          <div
            style={{
              backgroundColor: "#0B983A",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "75%",
              zIndex: 2,
            }}
          ></div>
          <div
            style={{
              backgroundColor: "#F1D91F",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 1,
            }}
          ></div>
          <img
            style={{
              position: "absolute",
              top: "50%",
              left: "76%",
              transform: "translate(-50%, -50%)",
              zIndex: 3,
            }}
            src="jiologo.png"
            alt="Jio BP Logo"
          />
        </div>

        <table className="pricing-table">
          <thead>
            <tr>
              <th style={{ textAlign: "left" }}>
                <span style={{ fontSize: "1.7rem" }}>
                  Date - {moment().format("DD-MM-YYYY")}
                  <br />
                  *Time at 6:00 am
                </span>
              </th>
              {/* <th
          style={{
            color: '#f4f4f4',
            textAlign: 'center',
            backgroundColor: '#0B983A',
            borderWidth: 10,
            borderColor: '#ffffff',
            margin: 10,
          }}
        >
          Petrol
        </th>
        <th
          style={{
            color: '#f4f4f4',
            textAlign: 'center',
            backgroundColor: '#004AAD',
            borderWidth: 10,
            borderColor: '#ffffff',
            margin: 10,
          }}
        >
          Diesel
        </th> */}
              <th style={headerStyle}>
                Stock
                <br />
                <span style={subHeaderStyle}>(L)</span>
              </th>
              <th style={headerStyle}>
                Density
                <br />
                <span style={subHeaderStyle}>(Kg/m³ *)</span>
              </th>
              <th style={headerStyle}>
                Rate
                <br />
                <span style={subHeaderStyle}>(₹/L)</span>
              </th>
            </tr>
          </thead>
          {/* <tbody>
      <tr>
        <td style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'left'}}>Stock<br /> 
        <span style={{fontWeight: 'normal' }}>(KL)</span>
          </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
            margin: 10,
          }}
        >
          <span className="highlight" id="petrolstock">
            {fuelData.petrolstock}
          </span>
        </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="dieselstock">
            {fuelData.dieselstock}
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ fontSize: '2rem' , fontWeight: 'bold', textAlign: 'left'}}>
        Density - UST 1 <br />
        <span style={{fontWeight: 'normal' }}> (Kg/m<sup>3</sup>)</span>
        </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="petroldensity">
            {fuelData.petroldensity}
          </span>
        </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="dieseldensity">
            {fuelData.dieseldensity}
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ fontSize: '2rem' , fontWeight: 'bold', textAlign: 'left'}}>
        Density - UST 2 <br />
        <span style={{fontWeight: 'normal' }}>(Kg/m<sup>3</sup>)</span>
        </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="petroldensity">
            {fuelData.petroldensity_ust2}
          </span>
        </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="dieseldensity">
            {fuelData.dieseldensity_ust2}
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ fontSize: '2rem' , fontWeight: 'bold', textAlign: 'left'}}>
        Density - UST 3 <br />
        <span style={{fontWeight: 'normal' }}> (Kg/m<sup>3</sup>)</span>
        </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="petroldensity">
            {fuelData.petroldensity_ust3}
          </span>
        </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="dieseldensity">
            {fuelData.dieseldensity_ust3}
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ fontSize: '2rem' , fontWeight: 'bold', textAlign: 'left'}}>
        Density - UST 4 <br />
        <span style={{fontWeight: 'normal' }}> (Kg/m<sup>3</sup>)</span>
        </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="petroldensity">
            {fuelData.petroldensity_ust4}
          </span>
        </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="dieseldensity">
            {fuelData.dieseldensity_ust4}
          </span>
        </td>
      </tr>
      <tr>
        
        <td style={{ fontSize: '2rem', fontWeight: 'bold' ,textAlign: 'left' }}>Rate <br />
        <span style={{fontWeight: 'normal' }}>(₹/L)</span>
          </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="petrolrate">
            {fuelData.petrolrate}
          </span>
        </td>
        <td
          style={{
            backgroundColor: '#000',
            borderWidth: 10,
            borderColor: '#ffffff',
          }}
        >
          <span className="highlight" id="dieselrate">
            {fuelData.dieselrate}
          </span>
        </td>
      </tr>
    </tbody> */}
          <tbody>
            {[
              // { ust: 'UST 1', type: 'Diesel', color: '#004AAD', stock: fuelData.diesel_ust1_stock, density: fuelData.dieseldensity_ust1, rate: fuelData.diesel_ust1_rate },
              // { ust: 'UST 2', type: 'Petrol', color: '#0B983A', stock: fuelData.petrol_ust2_stock, density: fuelData.petroldensity_ust2, rate: fuelData.petrol_ust2_rate },
              // { ust: 'UST 3', type: 'Petrol', color: '#0B983A', stock: fuelData.petrol_ust3_stock, density: fuelData.petroldensity_ust3, rate: fuelData.petrol_ust3_rate },
              // { ust: 'UST 4', type: 'Diesel', color: '#004AAD', stock: fuelData.diesel_ust4_stock, density: fuelData.dieseldensity_ust4, rate: fuelData.diesel_ust4_rate },
              {
                ust: "UST 1",
                // type: "Petrol",
                type: "EBMS",
                color: "#0B983A",
                stock: fuelData.petrol_ust2_stock,
                density: fuelData.petroldensity_ust2,
                rate: fuelData.petrol_ust2_rate,
              },
              {
                ust: "UST 2",
                type: "Diesel",
                color: "#004AAD",
                stock: fuelData.diesel_ust1_stock,
                density: fuelData.dieseldensity_ust1,
                rate: fuelData.diesel_ust1_rate,
              },
              {
                ust: "UST 3",
                type: "Diesel",
                color: "#004AAD",
                stock: fuelData.diesel_ust4_stock,
                density: fuelData.dieseldensity_ust4,
                rate: fuelData.diesel_ust4_rate,
              },
            ].map((row, index) => (
              <tr key={index}>
                <td
                  style={{
                    fontWeight: "bold",
                    fontSize: "2.5rem",
                    fontSize: "2rem",
                  }}
                >
                  {row.ust} -{" "}
                  <span style={{ color: row.color }}>{row.type}</span>
                </td>
                <td style={cellStyle}>
                  <span style={redText}>{row.stock}</span>
                </td>
                <td style={cellStyle}>
                  <span style={redText}>{row.density}</span>
                </td>
                <td style={cellStyle}>
                  <span
                    style={{
                      color: "#38B6FF",
                      fontWeight: "bold",
                      fontSize: "3rem",
                    }}
                  >
                    {row.rate}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <footer className="footer">
          <p
            style={{
              backgroundColor: "#10963D",
              padding: "20px 20px 20px 60px",
              color: "#FFFFFF",
              // borderRadius: 10,
              fontWeight: "bold",
              fontSize: "1.8rem",
            }}
          >
            <span
              style={{ fontWeight: "bold", color: "#FFFFFF", fontSize: "2rem" }}
            >
              {/* Reliance BP Mobility Limited */}
              Lohgarh Fuels
            </span>
            <br />
            <span style={{ color: "#ffffff", fontWeight: "normal" }}>
              {/* रिलायंस बीपी मोबिलिटी लिमिटेड */}
              लोहगढ़ फ्यूल्स
            </span>
            <br />
            <span style={{ color: "#FFFFFF", fontWeight: "normal" }}>
              GSTIN: {fuelData.gstnoreliancebp}
            </span>
            <br />
            <span style={{ fontWeight: "bold", color: "#FFFFFF" }}>
              RBML Solutions India Limited
            </span>
            <br />
            <span style={{ color: "#ffffff", fontWeight: "normal" }}>
              आरबीएमएल सोल्युशन्स इंडिया लिमिटेड
            </span>
            <br />
            <span style={{ color: "#FFFFFF", fontWeight: "normal" }}>
              GSTIN: 03AAKCR8762R1ZH
              <br />
              PESO Lic. No: {fuelData.pesono} Valid Upto: {fuelData.gstvalidity}
              <br />
              CNG PESO Lic. No : G/NC/PB/07/236(G94032) Valid Upto: 30.09.2028
            </span>
          </p>
          <div className="contacts">
            <p style={{ fontSize: "1.8rem" }}>
              <span style={{ fontSize: "2rem", fontWeight: "bold" }}>
                In case of Emergency:
              </span>
              <br />
              <span style={{ fontWeight: "bold" }}>
                POLICE: 100 | FIRE: 101 | HOSPITAL: 102
              </span>
              <br />
              <span style={{ color: "#000", fontWeight: "normal" }}>
                Name and Contact No. Area Manager:
              </span>
              <br />
              {fuelData.manager ? fuelData.manager.toUpperCase() : ""} -{" "}
              {fuelData.managerconatct || ""}
              <br />
              <span style={{ color: "#000", fontWeight: "normal" }}>
                Name and Contact No. RO Dealer:
              </span>
              <br />
              {fuelData.operator ? fuelData.operator.toUpperCase() : ""} -{" "}
              {fuelData.operatorcontact || ""}
            </p>
          </div>
          {/* <p>
      <span style={{ color: '#000000' }}>Internal Complaints Committee</span>
      <span style={{ color: '#2c85e1' }}> 
        <br />
        rbml.diversity@gmail.jiobp.com </span>
        <br />
         Contact: 022-31158910
    </p> */}
          <p
            style={{
              backgroundColor: "#10963D",
              color: "rgb(255, 255, 255)",
              margin: "0px",
              padding: "10px 60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontSize: "2rem" }}>
              For your valuable feedback call 1800-191-9023
              <br />
              or write to us at
              <br />
              coustomercare.petroleum@jiobp.com
            </span>
            <img
              src="qr.jpeg"
              alt="QR Code"
              style={{ height: "9rem", width: "auto", marginLeft: "20px" }}
            />
          </p>
          <span className="emergency">
            <b> RO Code - PBF042 &nbsp; &nbsp; &nbsp; RO Name-Zirakpur</b>
          </span>
        </footer>
      </div>{" "}
    </>
  );
};

export default HomePage;
